import { Sparkles } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

/**
 * Master v5 Prompt 30E — small badge shown next to a File that has one
 * or more published interactive WorkDocuments linked to it (via
 * WorkDocument.source_fas_id), so a client/coach immediately knows
 * this isn't just a static document anymore.
 */
export function InteractiveFileBadge({ testId }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wide text-terracotta bg-terracotta/10 rounded px-1.5 py-0.5 cursor-default"
            data-testid={testId || "interactive-file-badge"}
          >
            <Sparkles size={10} /> Interactive
          </span>
        </TooltipTrigger>
        <TooltipContent>This file has an interactive version. Click to open and interact</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
